module.exports = __webpack_public_path__ + "static/img/jianl.02455d53.png";